<template>
  <div class="bg-white form-sign-up shadow rounded-lg">
    <form class="p-4">
      <div class="mt-4">
        <div class="form-group">
          <label>{{ trans("account.fullname") }}</label>
          <input
            type="fullname"
            v-model="user.name"
            class="form-control form-control-lg bg-gray border-0"
            :class="{ 'is-invalid': $v.user.name.$error }"
          />
        </div>
        <div class="form-group">
          <label>{{ trans("account.email") }}</label>
          <input
                v-model="user.email"
                type="email"
                class="form-control form-control-lg bg-gray border-0"
                :class="{ 'is-invalid': $v.user.email.$error }"
          />
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label>{{ trans("account.dob") }}</label>
              <input
                v-model="user.dob"
                type="date"
                class="form-control form-control-lg bg-gray border-0"
                :class="{ 'is-invalid': $v.user.dob.$error }"
              />
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for>{{ trans("account.ethnicity") }}</label>
              <select v-model="user.ethnic" class="form-control form-control-lg border-0 bg-gray" :class="{ 'is-invalid': $v.user.ethnic.$error }">
                <option :value="null" selected>{{ trans("layout.please_select") }}</option>
                <option value="1">{{ trans("account.ethnicity_malay") }}</option>
                <option value="2">{{ trans("account.ethnicity_chinese") }}</option>
                <option value="3">{{ trans("account.ethnicity_indian") }}</option>
                <option value="4">{{ trans("account.ethnicity_others") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label>{{ trans("account.mykad") }}</label>
              <input v-model="user.mykad"
                type="text"
                class="form-control bg-gray border-0"
                :class="{ 'is-invalid': $v.user.mykad.$error }"
              />
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for>{{ trans("account.phone") }}</label>
              <input v-model="user.phone" type="text" class="form-control bg-gray border-0"
            :class="{ 'is-invalid': $v.user.phone.$error }"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label for="gender">{{ trans("account.gender") }}</label>
              <div class="btn-group btn-group-toggle btn-block" data-toggle="buttons">
                <label
                  class="btn btn-gray"
                  for="gender_male"
                  v-bind:class="[user.gender == 1 ? 'active' : '']"
                  @click="user.gender = 1"
                >
                  <input
                    id="gender_male"
                    v-model="user.gender"
                    type="radio"
                    name="Male"
                    autocomplete="off"
                    value="1"
                  />
                  {{ trans("account.male") }}
                </label>
                <label
                  for="gender_female"
                  class="btn btn-gray"
                  v-bind:class="[user.gender == 2 ? 'active' : '']"
                  @click="user.gender = 2"
                >
                  <input
                    id="gender_female"
                    v-model="user.gender"
                    type="radio"
                    name="Female"
                    autocomplete="off"
                    value="2"
                  />
                  {{ trans("account.female") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for>{{ trans("account.marital") }}</label>
              <select
                v-model="user.marital_status"
                class="form-control form-control-lg border-0 bg-gray"
                :class="{ 'is-invalid': $v.user.marital_status.$error }"
              >
                <option :value="null" selected>{{ trans("layout.please_select") }}</option>
                <option value="1">{{ trans("account.marital_single") }}</option>
                <option value="2">{{ trans("account.marital_married") }}</option>
                <option value="3">{{ trans("account.marital_divorced") }}</option>
                <option value="4">{{ trans("account.marital_widowed") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group">
              <label for>{{ trans("account.industry") }}</label>
              <select
                v-model="user.industry_id"
                class="form-control form-control-lg border-0 bg-gray"
                :class="{ 'is-invalid': $v.user.industry_id.$error }"
              >
                <option :value="null" selected>{{ trans("layout.please_select") }}</option>
                <option
                  v-for="industry in industries"
                  :key="industry.id"
                  :value="industry.id"
                >{{ industry.name }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <p class="text-danger" v-if="$v.$error">{{ trans('global.form-fill-error') }}</p>
          </div>
        </div>
        <button
          type="button"
          @click="handleOk"
          class="btn btn-block btn-primary py-3"
        >{{ trans("profile.complete_btn") }}</button>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return this.initData();
  },
  mounted() {
    this.loadUser();
  },
  validations: {
    user: {
        name: { required },
        email: { required },
        dob: { required },
        ethnic: { required },
        mykad: { required },
        phone: { required },
        gender: { required },
        marital_status: { required },
        industry_id: { required },
    }
  },
  methods: {
    initData() {
      return {
        user: {
          name: "",
          email: "",
          dob: "",
          ethnic: null,
          mykad: "",
          phone: "",
          gender: null,
          marital_status: null,
          industry_id: null,
        },
        validationErrors: '',
        industries: [],
      };
    },
    async loadUser() {
      let loader = this.$loading.show();
      try {
        var routeQuestion = "";
        if (window.current_lang == "en") {
          routeQuestion = route("api.en.industries.index");
        } else {
          routeQuestion = route("api.ms.industries.index");
        }

        const [user, industries] = await Promise.all([
          axios.get(route("api.account")),
          axios.get(routeQuestion),
        ]);
        this.industries = industries.data.data;
        this.user = user.data.data;
        loader.hide();
      } catch (e) {
        loader.hide();
        this.errorPopup(e.response.data.message);
      }
    },
    handleOk() {
      this.submit_store();
    },
    async submit_store() {
        this.$v.$touch()
        if (this.$v.$invalid) {
            console.log('error');
        } else {
            let loader = this.$loading.show();
            try {
                const { data } = await axios.post(route("api.completeProfile"), {
                    user: this.user,
                });
                window.location.href = route("en.result");
            } catch (e) {
                loader.hide();
                if (e.response.status == 422){
                    if(e.response.data){
                        if(e.response.data['user.dob']){
                            this.user.dob = null;
                            this.$v.user.dob.$touch();
                            this.errorPopup(e.response.data['user.dob']);
                        }
                        if(e.response.data['user.mykad']){
                            this.errorPopup(e.response.data['user.mykad']);
                        }
                    }
                }else{
                    this.errorPopup(e.response.data.message);
                }
            }
        }
    },
  },
};
</script>
